export const appendIfNotFalsy = (formData: FormData, key: string, value: any) => {
  if (value) {
    formData.append(key, value);
  }
};
